import { useContext, useEffect, useState } from 'react';
import { Button }                          from 'semantic-ui-react';
import AppContext                          from '../../../context/HeaderContext';
import BasicPaginatedTable                 from '../../../components/table/BasicPaginatedTable';
import CenterCell                          from '../../../components/table/CenterCell';
import Loading                             from '../../../components/Loading';
import { getAPI, deleteAPI }               from '../../../libs/fetchAPI';

function BrokenRunTests() {
	const { current_project_id }         = useContext(AppContext);
	const [ loading_ids, setLoadingIds ] = useState([]);
	const [ results, setResults ]        = useState(false);

	useEffect(() => {
		getAPI(`/broken_run?${new URLSearchParams({ project_id: current_project_id })}`).then((response) => {
			setResults(response.data);
		});
	}, [current_project_id, setResults]);

	function handleDelete(id) {
		setLoadingIds((prev) => [...prev, id]);

		deleteAPI(`/broken_run/${id}`).then(() => {
			setResults(results.filter(result => result.id !== id));
			setLoadingIds((prev) => prev.filter((loadingId) => loadingId !== id));
		});
	}

	const columns = [
		{
			Header   : `Created`,
			accessor : `created_at`,
			Cell     : ({ cell }) => <span>{new Date(`${cell.value} UTC`).toLocaleString()}</span>
		},
		{
			Header   : `Run Title`,
			accessor : `run_title`,
		},
		{
			Header   : `Spec File`,
			accessor : `spec_file`,
		},
		{
			Header   : `Version`,
			accessor : `version`,
		},
		{
			Header         : ``,
			accessor       : `id`,
			collapse       : true,
			disableFilters : true,
			Cell           : ({ row }) => {
				const id = row.original.id;

				return (
					<CenterCell>
						<Button className={`ui button red ${loading_ids.includes(row.original.id) ? 'loading' : ''}`} onClick={() => handleDelete(id)}>Delete</Button>
					</CenterCell>
				);
			}
		}
	];

	if(!results) {
		return <Loading />
	}

	return (
		<>
			<BasicPaginatedTable
				columns={columns}
				data={results}
				default_page_size="25"
			/>
		</>
	)
}

export default BrokenRunTests;
